import { ReactNode } from 'react';

interface Props {
  title: string;
  eyebrow?: string;
  description?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, eyebrow, description, actions }: Props) {
  return (
    <div className="border-b border-line bg-white px-4 py-6 md:px-8 md:py-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="min-w-0">
          {eyebrow && <div className="eyebrow">{eyebrow}</div>}
          <h1 className="mt-2 text-[22px] md:text-[26px] font-medium leading-tight tracking-tightest text-ink break-words">
            {title}
          </h1>
          {description && (
            <p className="mt-2 max-w-2xl text-[13px] text-ink/60">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 -mx-1 md:mx-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
